var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex button-wrapper"},[(_vm.settingsToggled)?_c('div',{staticClass:"d-flex d-flex-c menu-items-wrapper"},_vm._l((_vm.items),function(item,index){return _c('span',{key:index,class:[
        'menu-item',
        { [item.class]: item.class, 'is-disabled': item.enabled === false },
      ],on:{"click":() => _vm.handleItemSelect(item)}},[_vm._v(" "+_vm._s(item.label)+" ")])}),0):_vm._e(),_c('div',{staticClass:"blank-action-button",on:{"click":_vm.toggleSettings}},[_c('label',[_vm._v(_vm._s(_vm.label))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }